export const checkLocation = (includeVal: string) => {
	return window.location.pathname.includes(includeVal);
};
